module.exports = __webpack_public_path__ + "img/selo_site_seguro_norton_small.b7a9300.png";